module.exports = __webpack_public_path__ + "static/pic01-f243b136fdf1d8862a8a1e7f15673a4d.jpg";